<template>
  <div>
    <div class="finish_box">
      <div class="finish_title">
        <img src="../../image/finish_img.png" alt="" />
      </div>
      <div class="finish_text">您发布的房源已自动录入到房源列表</div>
      <div class="finish_btn">
        <button class="preview" @click="preview">预览详情</button>
        <button class="goback" @click="goback">返回列表</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "finish",
  data() {
    return {
      houseId: window.sessionStorage.getItem("hourId").toString() || ""
    };
  },
  methods: {
    goback() {
      this.$router.push({
        name: "managementList" //跳转的路径
      });
    },
    preview() {
      this.$router.push({
        name: "productDetails", //跳转的路径
        params: {
          houseId: this.houseId
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.finish_box {
  position: relative;
  margin: 56px 68px;
  background-color: #f6f6f6;
  // width: 1056px;
  height: 480px;
  .finish_title {
    width: 120px;
    height: 120px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 100px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .finish_text {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 250px;
    font-size: 20px;
    color: #666666;
  }
  .finish_btn {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 338px;
    .preview {
      cursor: pointer;
      width: 108px;
      height: 42px;
      background: #f6b439;
      border-radius: 4px;
      color: #fff;
      border: #f6b439;
      font-size: 20px;
    }
    .goback {
      cursor: pointer;
      width: 108px;
      height: 42px;
      background: #2f80ed;
      border-radius: 4px;
      color: #fff;
      border: #2f80ed;
      font-size: 20px;
      margin-left: 44px;
    }
  }
}
</style>
